import { camelizeKeys } from 'humps';
import { checkForHTTP, displayNameToStringProto } from './utils';

let http;

/**
 * Gets list of vehicle makes from the gold api.
 * @returns {Promise} Array of make objects.
 */
export const getMakes = () => checkForHTTP(http).get('/gold/vehicle-info/makes')
  .then(({ body }) => body)
  .then(camelizeKeys)
  .then(makes => makes.map(make => Object.assign(make, displayNameToStringProto)));

/**
 * Gets list of models for a given make from gold api.
 * @param {string} makeId
 * @returns {Promise} model object.
 */
export const getModels = (makeId) => checkForHTTP(http).get(`/gold/vehicle-info/make/${makeId}`)
  .then(({ body }) => body.Ymmts)
  .then(camelizeKeys);

/**
 * Initizalize the gold api module with a `superagent` instance that is configure for a specific environment.
 * @param {superagent} http
 */
export default ({ http: _http }) => {
  http = _http;
};



// WEBPACK FOOTER //
// ./src/api-purecars/gold-vehicles.js